import { render, staticRenderFns } from "./MyMessages.vue?vue&type=template&id=3aefbd87&scoped=true&"
import script from "./MyMessages.vue?vue&type=script&lang=ts&"
export * from "./MyMessages.vue?vue&type=script&lang=ts&"
import style0 from "./MyMessages.vue?vue&type=style&index=0&id=3aefbd87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aefbd87",
  null
  
)

export default component.exports